export default "__VITE_ASSET__CtbM3WDq__"